import { PlacementSearchFilterName } from '@AMIEWEB/GlobalSearch/Placement/SearchUtils';

export const setFilterValues = setValue => {
  setValue(PlacementSearchFilterName.extensionStatus, []);
  setValue(PlacementSearchFilterName.pid, []);
  setValue(PlacementSearchFilterName.candidate, []);
  setValue(PlacementSearchFilterName.startDate, []);
  setValue(PlacementSearchFilterName.endDate, []);
  setValue(PlacementSearchFilterName.recruiter, []);
  setValue(PlacementSearchFilterName.accountManager, []);
  setValue(PlacementSearchFilterName.credentialingAnalyst, []);
  setValue(PlacementSearchFilterName.placementCuedTo, []);
  setValue(PlacementSearchFilterName.region, []);
};
